export default {
	idAta: null,
	idsItensAta: [],
	percentual: null,
}
